import { jsx as _jsx } from "react/jsx-runtime";
import { getCart, useCartStore } from '../../store/cart';
import Cart from './summary/cart';
import CartOrderDetails from './order/cart-order-details';
import { Step } from '../../store/cart';
import CartEmpty from './empty';
import Loader from '../loader';
import { useGlobalSettings } from '../global-settings';
export default function CartTemplate() {
    const step = useCartStore((state) => state.step);
    const cart = useCartStore((state) => state.cart);
    const setCart = useCartStore((state) => state.set);
    const { isInited } = useGlobalSettings(async (config) => {
        const cart = await getCart(config.api.cart.get);
        setCart(cart);
    });
    if (!isInited)
        return _jsx(Loader, {});
    if (cart.items.length === 0)
        return _jsx(CartEmpty, {});
    return step === Step.SUMMARY ? _jsx(Cart, {}) : _jsx(CartOrderDetails, {});
}
